<template>
  <div>
    <TopHeader code="topic" />

    <section class="container-fluid uc-bg2">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link :to="{ name: 'Topic' }" class="item"
                >社区</router-link
              >
              <router-link to="" class="item">话题详情</router-link>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-24">
            <section class="uc-CultivateDetailBox uc-TopicDetailBox">
              <div class="banner-box">
                <img src="../../assets/images/banner-topic.png" />
                <div class="txt">{{ model.title }}</div>
              </div>
              <div class="btm">
                <div class="left">
                  <div class="intro">
                    {{ model.description }}
                  </div>
                  <div class="operate">
                    <router-link
                      to=""
                      class="uc-btn black el-icon-edit"
                      @click.native="dialogVisible = true"
                      >参与话题</router-link
                    >
                    <div class="avatar-list">
                      <img
                        v-for="(item2, index2) in model.top5_answer_user"
                        :key="index2"
                        :src="item2.avatar"
                        :alt="item2.first_name"
                        :style="index2 == 0 ? 'margin-left:0;' : ''"
                        onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
                      />
                    </div>
                    <span class="uc-phColor uc-pr30"
                      >{{ model.topic_answer_count }}人参与讨论</span
                    >
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>

    <el-dialog
      title="发布回答"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="form">
        <el-input
          type="textarea"
          v-model="form.content"
          autocomplete="off"
          placeholder="写下你想说的话~"
          @keyup.native="form.disabled = form.content.trim() == ''"
        ></el-input>
        <el-upload
          ref="upload"
          class="pic-upload"
          action="#"
          list-type="picture-card"
          accept=".jpg,.png"
          :on-preview="handlePictureCardPreview"
          :auto-upload="false"
          :multiple="true"
          :limit="9"
          :on-exceed="handleExceed"
          :on-change="handleChange"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过5MB，最多上传9个
          </div>
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="form.disabled"
          @click.native="submitAnswer"
          >发 布</el-button
        >
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogImageVisible">
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>

    <section class="container-fluid uc-bg uc-pt20 uc-pb40">
      <div class="container">
        <div class="row">
          <div class="col-24 col-sm-17">
            <section
              class="uc-CourseDetailContent uc-TopicDetailContent uc-mr10 uc-pb20"
            >
              <div class="hd">
                <div class="txt">{{ answerCount }}个回答</div>
                <div class="right">
                  <a
                    href="javascript:;"
                    :class="query2.orderby == 0 ? 'on' : ''"
                    @click="loadResetAnswer(0)"
                    >最新</a
                  >
                  <a
                    href="javascript:;"
                    :class="query2.orderby == 1 ? 'on' : ''"
                    @click="loadResetAnswer(1)"
                    >最热</a
                  >
                </div>
              </div>
              <div class="content-empty" v-show="answerList.length == 0">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
              <div
                class="item"
                v-for="(item, index) in answerList"
                :key="index"
              >
                <div class="meta">
                  <div class="info">
                    <img
                      :src="item.create_user_avatar"
                      :alt="item.create_user_name"
                      onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
                    />
                    <div class="content">
                      <div class="name">
                        {{ item.create_user_name
                        }}<img
                          class="icon-credit"
                          :src="item.credit_icon"
                          :alt="item.credit_name"
                          v-if="item.credit_icon"
                        /><span v-else>--{{ item.credit_name }}</span>
                        <img
                          class="icon-ding"
                          src="../../assets/images/jing.png"
                          v-if="item.is_essence"
                        />
                      </div>
                      <div class="desc"></div>
                    </div>
                  </div>
                  <div class="time">{{ item.create_time }}</div>
                </div>
                <div
                  class="content"
                  :class="{ active: item.isShowMore }"
                  v-html="item.content"
                ></div>
                <div class="img-list" v-if="item.attachment_paths">
                  <el-image
                    v-for="(item2, index2) in item.attachment_paths.split(',')"
                    :key="index2"
                    :src="item2"
                    fit="cover"
                    :preview-src-list="item.attachment_paths.split(',')"
                  >
                  </el-image>
                </div>
                <div class="action">
                  <div>
                    <el-button
                      type="primary"
                      :plain="!item.is_likes"
                      :disabled="item.likesDisabled"
                      class="el-icon-caret-top"
                      @click.native="likesAltAnswer(item)"
                      >&nbsp;{{ item.is_likes ? '已赞同' : '赞同' }}&nbsp;{{
                        item.topic_answer_likes_count
                      }}</el-button
                    >
                    <a
                      href="javascript:;"
                      class="el-icon-chat-dot-round"
                      @click="showAltReply(item)"
                      >&nbsp;{{
                        item.isShowReply
                          ? '收起评论'
                          : `${item.topic_reply_count}条评论`
                      }}</a
                    >
                    <a
                      href="javascript:;"
                      class="el-icon-delete"
                      v-if="item.is_delete"
                      @click="deleteAnswer(item)"
                      >&nbsp;删除</a
                    >
                  </div>
                  <a
                    href="javascript:;"
                    v-if="item.isDescStatus"
                    @click="item.isShowMore = !item.isShowMore"
                    >{{ item.isShowMore ? '展开' : '收起' }}&nbsp;<span
                      :class="`el-icon-arrow-${
                        item.isShowMore ? 'down' : 'up'
                      }`"
                    ></span
                  ></a>
                </div>
                <div class="comment" v-if="item.isShowReply">
                  <div class="c-editor">
                    <el-input
                      type="text"
                      v-model="item.reply_content"
                      autocomplete="off"
                      placeholder="写下你的评论~"
                      @keyup.native="handleKeyup(item)"
                    ></el-input>
                    <el-button
                      type="primary"
                      :disabled="item.disabled"
                      @click.native="submitReply(item, item, item)"
                      >发 布</el-button
                    >
                  </div>
                  <div class="hd">
                    <div class="txt">{{ item.topic_reply_count }}条评论</div>
                  </div>
                  <div class="no-data" v-if="item.topic_reply_count == 0">
                    暂无评论
                  </div>
                  <div
                    class="c-item"
                    v-for="(item2, index2) in item.topic_reply_list"
                    :key="index2"
                  >
                    <div class="meta">
                      <div class="info">
                        <img
                          :src="item2.create_user_avatar"
                          :alt="item2.create_user_name"
                          onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
                        />
                        <div class="content">
                          <div class="name">{{ item2.create_user_name }}</div>
                          <div class="desc">{{ item2.create_time }}</div>
                        </div>
                      </div>
                      <div class="tools">
                        <a
                          href="javascript:;"
                          class="el-icon-chat-dot-round"
                          @click="item2.isShowEditor = !item2.isShowEditor"
                          >&nbsp;{{ item2.isShowEditor ? '取消' : '' }}回复</a
                        >
                        <a
                          href="javascript:;"
                          class="el-icon-delete"
                          v-if="item2.is_delete"
                          @click="deleteReply(item, item, item2)"
                          >&nbsp;删除</a
                        >
                      </div>
                    </div>
                    <div class="body">
                      <div class="content" v-html="item2.content"></div>
                      <div class="c-editor" v-show="item2.isShowEditor">
                        <el-input
                          type="text"
                          v-model="item2.reply_content"
                          autocomplete="off"
                          :placeholder="`回复${item2.create_user_name}`"
                          @keyup.native="handleKeyup(item2)"
                        ></el-input>
                        <el-button
                          type="primary"
                          :disabled="item2.disabled"
                          @click.native="submitReply(item, item2, item2)"
                          >发 布</el-button
                        >
                      </div>
                      <div
                        class="c-item"
                        v-for="(item3, index3) in item2.topic_reply_list"
                        :key="index3"
                      >
                        <div class="meta">
                          <div class="info">
                            <img
                              :src="item3.create_user_avatar"
                              :alt="item3.create_user_name"
                              onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
                            />
                            <div class="content">
                              <div class="name">
                                {{ item3.create_user_name
                                }}<span class="c-reply">回复</span
                                >{{ item3.reply_user_name }}
                              </div>
                              <div class="desc">
                                {{ item3.create_time }}
                              </div>
                            </div>
                          </div>
                          <div class="tools">
                            <a
                              href="javascript:;"
                              class="el-icon-chat-dot-round"
                              @click="item3.isShowEditor = !item3.isShowEditor"
                              >&nbsp;{{
                                item3.isShowEditor ? '取消' : ''
                              }}回复</a
                            >
                            <a
                              href="javascript:;"
                              class="el-icon-delete"
                              v-if="item3.is_delete"
                              @click="deleteReply(item, item2, item3)"
                              >&nbsp;删除</a
                            >
                          </div>
                        </div>
                        <div class="body">
                          <div class="content" v-html="item3.content"></div>
                          <div class="c-editor" v-show="item3.isShowEditor">
                            <el-input
                              type="text"
                              v-model="item3.reply_content"
                              autocomplete="off"
                              :placeholder="`回复${item3.create_user_name}`"
                              @keyup.native="handleKeyup(item3)"
                            ></el-input>
                            <el-button
                              type="primary"
                              :disabled="item3.disabled"
                              @click.native="submitReply(item, item2, item3)"
                              >发 布</el-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="more"
                    v-if="item.topic_reply_list.length < item.replyCount"
                  >
                    <a href="javascript:;" @click="loadMoreReply(item)"
                      >点击加载更多</a
                    >
                  </div>
                </div>
              </div>
              <div class="more" v-if="answerList.length < answerCount">
                <a href="javascript:;" @click="loadMoreAnswer">点击加载更多</a>
              </div>
            </section>
          </div>
          <!-- 相关话题 -->
          <div class="col-24 col-sm-7">
            <section class="g-sideCourseList">
              <div class="title">相关话题</div>
              <div class="content-empty" v-show="topicList.length == 0">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
              <div class="list">
                <div
                  class="item"
                  v-for="(item, index) in topicList"
                  :key="index"
                >
                  <router-link
                    :to="{
                      name: 'TopicDetails',
                      params: { id: item.id },
                    }"
                    class="img-box"
                  >
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../../assets/images/default-ht.png" />
                      </div>
                    </el-image>
                  </router-link>
                  <div class="con">
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :content="item.title"
                    >
                      <h3>{{ item.title }}</h3>
                    </el-tooltip>
                    <div class="txt">
                      {{ item.description }}
                    </div>
                    <div class="btm">
                      {{ item.topic_answer_count }}人参与讨论
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'TopicDetails',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      query: {
        id: this.$route.params.id,
      },
      query2: {
        questionId: this.$route.params.id,
        pageIndex: 1,
        pageSize: 10,
        orderby: 0,
      },
      model: {},
      topicList: {},
      answerCount: 0,
      answerList: {},
      dialogVisible: false,
      form: {
        questionId: this.$route.params.id,
        content: '',
        files: [],
        disabled: true,
      },
      dialogImageUrl: '',
      dialogImageVisible: false,
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.$router.go(0);
    },
  },
  methods: {
    loadData() {
      this.getTopicDetails();
      this.getRelatedTopics();
      this.getTopicAnswers();
    },
    // 相关话题
    async getRelatedTopics() {
      const response = await this.$api.topic.getRelatedTopics(this.query);
      this.topicList = response.data.data;
    },
    // 话题详情
    async getTopicDetails() {
      const response = await this.$api.topic.getTopicDetails(this.query);
      this.model = response.data.data;
    },
    // 重置回答
    resetAnswer(item) {
      if (item.content.length > 150) {
        item.isShowMore = true;
        item.isDescStatus = true;
      } else {
        item.isShowMore = false;
        item.isDescStatus = false;
      }
      item.likesDisabled = false;
      item.isShowReply = false;
      item.isLoadReply = false;
      item.query = {
        answerId: item.id,
        pageIndex: 1,
        pageSize: 5,
      };
      item.replyCount = 0;
      item.topic_reply_list = [];
      item.disabled = true;
      item.reply_content = '';
    },
    // 回答列表
    async getTopicAnswers() {
      const response = await this.$api.topic.getTopicAnswers(this.query2);
      const data = response.data.data;
      this.answerCount = data.total_count;
      if (!(this.answerList instanceof Array)) {
        this.answerList = [];
      }
      for (const item of data.items) {
        this.resetAnswer(item);
        this.answerList.push(item);
      }
    },
    // 加载并重置回答
    loadResetAnswer(orderby) {
      this.query2.pageIndex = 1;
      this.query2.orderby = orderby;
      this.answerList = {};
      this.getTopicAnswers();
    },
    // 加载更多回答
    loadMoreAnswer() {
      this.query2.pageIndex++;
      this.getTopicAnswers();
    },
    // 加载更多评论
    loadMoreReply(item) {
      item.query.pageIndex++;
      this.getTopicReplys(item);
    },
    handleKeyup(item) {
      item.disabled = item.reply_content.trim() === '';
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogImageVisible = true;
    },
    handleExceed() {
      this.$message.error('最多上传 9 张图片!');
    },
    handleChange(file, fileList) {
      const allowExt =
        file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const allowSize = file.size / 1024 / 1024 < 5;
      const index = fileList.indexOf(file);
      if (!allowExt) {
        fileList.splice(index, 1);
        this.$message.error('上传图片只能是 jpg/png 格式!');
      }
      if (!allowSize) {
        fileList.splice(index, 1);
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      this.form.files.push(file.raw);
    },
    // 重置表单
    resetForm() {
      this.$refs.upload.clearFiles();
      this.form.content = '';
      this.form.files = [];
      this.form.disabled = true;
    },
    // 提交回答
    submitAnswer() {
      const formData = new FormData();
      formData.append('questionId', this.form.questionId);
      formData.append('content', this.form.content);
      for (const file of this.form.files) {
        formData.append('files', file);
      }
      this.$api.topic
        .submitAnswerFile(formData)
        .then((response) => {
          if (response.data.code === 200) {
            this.answerCount++;
            const data = response.data.data;
            this.resetAnswer(data);
            this.answerList.splice(0, 0, data);
            this.$message.success(response.data.message);
            this.dialogVisible = false;
            this.resetForm();
          } else {
            this.$message.warning(response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 删除回答
    deleteAnswer(item) {
      this.$confirm(`确定要删除该回答吗？`, '提示', {
        type: 'warning',
      }).then(() => {
        this.$api.topic
          .deleteTopicAnswer({ id: item.id })
          .then((response) => {
            if (response.data.code === 200) {
              this.answerCount--;
              this.answerList.splice(this.answerList.indexOf(item), 1);
              this.$message.success(response.data.message);
            } else {
              this.$message.warning(response.data.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    // 点赞/取消点赞
    likesAltAnswer(item) {
      item.likesDisabled = true;
      this.$api.topic
        .likesOrCancelTopicAnswer({ answerId: item.id })
        .then((response) => {
          item.likesDisabled = false;
          if (response.data.code === 200) {
            if (item.is_likes) {
              item.is_likes = false;
              item.topic_answer_likes_count--;
            } else {
              item.is_likes = true;
              item.topic_answer_likes_count++;
            }
          } else {
            this.$message.warning(response.data.message);
          }
        })
        .catch((error) => {
          item.likesDisabled = false;
          console.log(error);
        });
    },
    // 显示/隐藏评论
    async showAltReply(item) {
      if (!item.isLoadReply && item.topic_reply_count > 0) {
        await this.getTopicReplys(item);
      }
      item.isShowReply = !item.isShowReply;
      item.isLoadReply = true;
    },
    // 重置评论框
    resetEditor(item) {
      item.isShowEditor = false;
      item.disabled = true;
      item.reply_content = '';
    },
    // 评论列表
    async getTopicReplys(item) {
      const response = await this.$api.topic.getTopicReplys(item.query);
      const data = response.data.data;
      item.replyCount = data.total_count;
      for (const item2 of data.items) {
        this.resetEditor(item2);
        for (const item3 of item2.topic_reply_list) {
          this.resetEditor(item3);
        }
        item.topic_reply_list.push(item2);
      }
    },
    // 提交回复
    submitReply(answer, parent, self) {
      const submitData = {
        question_id: answer.question_id,
        answer_id: answer.id,
        content: self.reply_content,
      };
      if (answer !== self) {
        submitData.reply_id = self.id;
        submitData.reply_user_id = self.create_user_id;
      }
      this.$api.topic
        .submitReply(submitData)
        .then((response) => {
          if (response.data.code === 200) {
            answer.topic_reply_count++;
            const data = response.data.data;
            data.topic_reply_list = [];
            this.resetEditor(data);
            if (answer !== self) {
              data.reply_user_name = self.create_user_name;
              data.reply_user_avatar = self.create_user_avatar;
              parent.topic_reply_list.splice(
                parent.topic_reply_list.indexOf(self) + 1,
                0,
                data
              );
            } else {
              answer.replyCount++;
              parent.topic_reply_list.splice(0, 0, data);
            }
            this.resetEditor(self);
            this.$message.success(response.data.message);
          } else {
            this.$message.warning(response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 刪除回复
    deleteReply(answer, parent, self) {
      this.$confirm(`确定要删除该回复吗？`, '提示', {
        type: 'warning',
      }).then(() => {
        this.$api.topic
          .delReply({ id: self.id })
          .then((response) => {
            if (response.data.code === 200) {
              if (answer !== parent) {
                const arr = parent.topic_reply_list;
                for (let i = arr.length - 1; i >= 0; i--) {
                  if (arr[i].path.startsWith(self.path)) {
                    answer.topic_reply_count--;
                    arr.splice(i, 1);
                  }
                }
              } else {
                answer.replyCount--;
                answer.topic_reply_count -=
                  1 + (self.topic_reply_list || []).length;
                parent.topic_reply_list.splice(
                  parent.topic_reply_list.indexOf(self),
                  1
                );
              }
              this.$message.success(response.data.message);
            } else {
              this.$message.warning(response.data.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
  },
};
</script>
